<template>
  <div class="pluginPage">
    <el-table
          stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80:50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      
      <el-table-column
        prop="customerId"
        label="客户"
        min-width="130"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pluginName"
        label="插件名称"
        min-width="130"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.pluginName">{{scope.row.pluginName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="pluginType !== 'cc.aoni.aim.api.plugin.AimV4Plugin'"
        prop="productType"
        label="产品类型"
        min-width="110"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.productType">{{scope.row.productType.title}}</span>
          <span v-else>通用</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="pluginType !== 'cc.aoni.aim.api.plugin.AimV4Plugin'"
        prop="productId"
        label="产品型号"
        min-width="110"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.product">{{scope.row.product.name}}</span>
          <span v-else>通用</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bean"
        label="Bean"
        min-width="130"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.beanClass"
            placement="top"
            :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.bean">{{scope.row.bean}}</div>
          </el-tooltip>
          <span v-if="!scope.row.bean">-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="95px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <i @click="editPlugin($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <i @click="deletePlugin($event, scope.row)" class="el-icon-delete"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getCustomerPluginSearch"
    ></pagination>
    <myDialog
      ref="pluginDialog"
      :title="pluginDialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="pluginDialogForm"
          :model="pluginDialogForm"
          :rules="pluginDialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="客户：" size="small" prop="customerId">
            <el-select
              v-model="pluginDialogForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="pluginType !== 'cc.aoni.aim.api.plugin.AimV4Plugin'" label="产品类别：" size="small" prop="productType">
            <el-select
              v-model="pluginDialogForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="pluginType !== 'cc.aoni.aim.api.plugin.AimV4Plugin'" label="产品型号：" size="small" prop="productId">
            <el-select
              v-model="pluginDialogForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.addProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="插件名称：" size="small" prop="bean">
            <el-select v-model="pluginDialogForm.bean" placeholder="选择插件名称" filterable clearable>
              <el-option
                v-for="(item, index) in $parent.pullDownData.pluginList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiCustomerPluginSearch,
  apiCustomerPluginAdd,
  apiCustomerPluginUpdate,
  apiCustomerPluginDelete,
  apiCustomerPluginDisable,
  apiCustomerPluginEnable
} from "@/api/customerManage.js";

export default {
  components: {
    pagination,
    myDialog
  },
  props: {
    pluginType: {
      type: String
    },
    pluginSearchForm: {
      type: Object
    }
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      pluginDialogTitle: "",
      pluginDialogForm: {},
      pluginDialogRules: {
        customerId: [
          { required: true, message: "客户名称不能为空！", trigger: "change" }
        ],
        // productType: [
        //   { required: true, message: "产品类别不能为空！", trigger: "change" }
        // ],
        // productId: [
        //   { required: true, message: "产品型号不能为空！", trigger: "change" }
        // ],
        bean: [
          { required: true, message: "插件名称不能为空！", trigger: "change" }
        ]
      },
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    // 表格数据
    async getCustomerPluginSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiCustomerPluginSearch({
        ...this.pluginSearchForm,
        type: this.pluginType,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getCustomerPluginSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getCustomerPluginSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getCustomerPluginSearch();
    },
    // 添加客户插件
    addPlugin() {
      this.pluginDialogTitle = "添加客户插件";
      this.$refs.pluginDialog.dialogVisible = true;
    },
    // 修改客户插件
    editPlugin(e, row) {
      this.pluginDialogTitle = "修改客户插件";
      this.pluginDialogForm = {
        id: row.id,
        bean: row.bean,
        customerId: row.customer.id,
        type: row.type
      }
      if (this.pluginType !== 'cc.aoni.aim.api.plugin.AimV4Plugin' && row.productType) {
        this.productTypeChange(row.productType.code);
        this.pluginDialogForm.productType = row.productType.code;
        this.pluginDialogForm.productId = row.product ? row.product.id : undefined;
      }
      this.$refs.pluginDialog.dialogVisible = true;
    },
    // 对话框确定
    submitData(title) {
      this.$refs.pluginDialogForm.validate(async valid => {
        if (valid) {
          if (title == "添加客户插件") {
            const res = await apiCustomerPluginAdd({
              ...this.pluginDialogForm,
              type: this.pluginType
            });
            if (res.code == 0) {
              this.$refs.pluginDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getCustomerPluginSearch();
              this.$message({
                type: "success",
                message: "添加成功"
              });
            }
          } else if (title == "修改客户插件") {
            const res = await apiCustomerPluginUpdate({
              ...this.pluginDialogForm,
              type: this.pluginType
            });
            if (res.code == 0) {
              this.$refs.pluginDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getCustomerPluginSearch("noRemove");
              this.$message({
                type: "success",
                message: "修改成功"
              });
            }
          }
        } else {
          this.$message({
            type: "error",
            message: "表单校验失败"
          });
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.pluginDialogForm.resetFields();
      this.pluginDialogForm = {};
      this.$parent.pullDownData.addProductList = [];
    },
    // 删除插件
    deletePlugin(e, row) {
      e.target.blur();
      this.$allOperation({name:row.pluginName}, "删除", "插件名称").then(async () => {
        const res = await apiCustomerPluginDelete({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getCustomerPluginSearch("noRemove");
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    },
    // 禁用插件
    disablePlugin(e, row) {
      e.target.blur();
      this.$allOperation({name:row.pluginName}, "禁用", "插件名称").then(async () => {
        const res = await apiCustomerPluginDisable({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getCustomerPluginSearch("noRemove");
          this.$message({
            message: "禁用成功",
            type: "success"
          });
        }
      });
    },
    // 启用插件
    enablePlugin(e, row) {
      e.target.blur();
      this.$allOperation({name:row.bean}, "启用", "插件").then(async () => {
        const res = await apiCustomerPluginEnable({
          id: row.id
        });
        // console.log(res)
        if (res.code == 0) {
          this.getCustomerPluginSearch("noRemove");
          this.$message({
            message: "启用成功",
            type: "success"
          });
        }
      });
    },
    // 产品类别改变
    productTypeChange(value) {
      this.$set(this.pluginDialogForm, "productId", undefined);
      this.$parent.pullDownData.addProductList = [];
      if (value) {
        this.$parent.getProductList(value, "addProductList");
      }
    }
  }
};
</script>

<style lang="less" scope>
.pluginPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>